import React  from 'react';
function NotFoundComp() {
    return (
    <main style={{ marginTop: '64px', padding: '16px' }}>
      <h1 style={{ textAlign: 'center' }}>Not Found</h1>
      <p>Page not found</p>
    </main>
  );
}

export default NotFoundComp;
